module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAIAAAAlV+npAAABPUlEQVR4AWLw89M9KWJySYAwGkUMDEWaSsla6wHt1yVQhHEURfGHuzcK7q694JDwgic0IpVE7wNtSdBn6GE7CW90vOCQuY9NO/9z5/VwZn6flLbTQor1cWkb9btdLeQQYv2egySxIOmIBUlvLEj6Y31cxUKDSpJYMkli+UkSy0+SWDJJYvlJEstPklgfl75R90GSWJB0xtKvaqP7ZGnlZn4rhIs11sdlbrXtR4/eApgQS7vZyPb9yyOx1KvfGz69PSeWg+RB9JhYjpuL7KgkiaWTJJafJLHcJIk1f0gsGOrHAx56fJTG7e8OsfRPBGKp9IiVu9baOz0yFsZii9VXbCmJFsz+G2u9xurz7O8Ra7bcitIsxEFPn4derTXkWdCDnj4PPQY9fR56DHr6PPQY9PR56DHo6fPQY/3QU/cOXINP+3oe9JsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/sd.png
// module id = rbZu
// module chunks = 0